import React from 'react'
import { Route } from 'react-router'
// import PageTracker from "../../tracking/page_tracker";

class RouterTracker extends React.Component {
    // constructor() {
    //     super();
    //     // this.pageTracker=new PageTracker();
    // }

    track = () => {
        // this.pageTracker.track();
    }

    componentWillMount() {
        this.track()
    }

    componentWillUpdate() {
        this.track()
    }
    render() {
        return <Route children={this.props.children} />
    }
}

export default RouterTracker
